import { render, staticRenderFns } from "./LoginDialogTemplate.vue?vue&type=template&id=2148ed65&scoped=true"
import script from "./LoginDialogTemplate.vue?vue&type=script&lang=ts"
export * from "./LoginDialogTemplate.vue?vue&type=script&lang=ts"
import style0 from "./LoginDialogTemplate.vue?vue&type=style&index=0&id=2148ed65&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2148ed65",
  null
  
)

export default component.exports